<tran-application-detail-dashboard-box [heading]="heading()">
    @if (isLoading()) {
        <div class="flex flex-col gap-3" aria-hidden="true">
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-[90%]"></span>
            <span class="si-skeleton placeholder-lg w-[75%]"></span>
        </div>
    } @else {
        <si-form-item label="" [formErrorMapper]="{ required: 'application-form.required' | translate }">
            <textarea
                class="form-control"
                [placeholder]="placeholder() | translate"
                [readonly]="readonly() || effectiveControl().disabled"
                [formControl]="effectiveControl()"
            ></textarea>
        </si-form-item>
    }
</tran-application-detail-dashboard-box>
